import { render, staticRenderFns } from "./channelChangeStatistics.vue?vue&type=template&id=4d54097c&"
import script from "./channelChangeStatistics.vue?vue&type=script&lang=js&"
export * from "./channelChangeStatistics.vue?vue&type=script&lang=js&"
import style0 from "./channelChangeStatistics.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports